import React, { Component } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import { Link } from "react-router-dom";
import LoadMask from "Utils/LoadMask/LoadMask";
import { tableOptions, BreakLine } from "Utils/tableOptions";
import Toolbar from "Utils/Toolbar/Toolbar";
import { icons } from "icons";
import {
    RenderImage,
    RenderDateTime,
    RenderMoneda,
} from "Utils/renderField/renderTableField";
import { ActionItem, HeaderItem } from "react-dropdown-advanced";
import ModalAyuda from "Utils/Ayuda";
import { formatoCostoDolares } from "../../Utils/CamposComunes";

import icono_traslados from "../../../../../assets/img/iconos/icono-traslado-productos.png";
import icono_devolucion from "../../../../../assets/img/iconos/icono-devolucion-compra.png";
import icono_ordenes_venta from "../../../../../assets/img/iconos/icono-orden-venta.png";
import icono_reajuste from "../../../../../assets/img/iconos/icono-reajuste.png";

class Apertura extends Component {
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            dropdownItems: [
                new HeaderItem("¿Con qué necesitas ayuda?"),
                new ActionItem(
                    "ingreso",
                    "¿Cómo realizar un ingreso de mercadería?"
                ),
                new ActionItem("baja", "¿Cómo realizar un reporte de baja?"),
                new ActionItem("reajuste", "¿Cómo realizar un reajuste?"),
            ],
            modalAyuda: false,
            itemsImagenes: [],
            itemsBodegaIngreso: [
                {
                    src: icons.bodega_ingreso_p1,
                    alt: "Paso 1",
                },
                {
                    src: icons.bodega_ingreso_p2,
                    alt: "Paso 2",
                },
                {
                    src: icons.bodega_ingreso_p3,
                    alt: "Paso 3",
                },
                {
                    src: icons.bodega_ingreso_p4,
                    alt: "Paso 4",
                },
                {
                    src: icons.bodega_ingreso_p5,
                    alt: "Paso 5",
                },
                {
                    src: icons.bodega_ingreso_p6,
                    alt: "Paso 6",
                },
                {
                    src: icons.bodega_ingreso_p7,
                    alt: "Paso 7",
                },
                {
                    src: icons.bodega_ingreso_p8,
                    alt: "Paso 8",
                },
                {
                    src: icons.bodega_ingreso_p9,
                    alt: "Paso 9",
                },
                {
                    src: icons.bodega_ingreso_p10,
                    alt: "Paso 10",
                },
                {
                    src: icons.bodega_ingreso_p11,
                    alt: "Paso 11",
                },
                {
                    src: icons.bodega_ingreso_p12,
                    alt: "Paso 12",
                },
            ],
            itemsBodegaBaja: [
                {
                    src: icons.bodega_baja_p1,
                    alt: "Paso 1",
                },
                {
                    src: icons.bodega_baja_p2,
                    alt: "Paso 2",
                },
                {
                    src: icons.bodega_baja_p3,
                    alt: "Paso 3",
                },
                {
                    src: icons.bodega_baja_p4,
                    alt: "Paso 4",
                },
                {
                    src: icons.bodega_baja_p5,
                    alt: "Paso 5",
                },
                {
                    src: icons.bodega_baja_p6,
                    alt: "Paso 6",
                },
                {
                    src: icons.bodega_baja_p7,
                    alt: "Paso 7",
                },
                {
                    src: icons.bodega_baja_p8,
                    alt: "Paso 8",
                },
            ],
            itemsBodegaReajuste: [
                {
                    src: icons.bodega_reajuste_p1,
                    alt: "Paso 1",
                },
                {
                    src: icons.bodega_reajuste_p2,
                    alt: "Paso 2",
                },
                {
                    src: icons.bodega_reajuste_p3,
                    alt: "Paso 3",
                },
                {
                    src: icons.bodega_reajuste_p4,
                    alt: "Paso 4",
                },
                {
                    src: icons.bodega_reajuste_p5,
                    alt: "Paso 5",
                },
                {
                    src: icons.bodega_reajuste_p6,
                    alt: "Paso 6",
                },
                {
                    src: icons.bodega_reajuste_p7,
                    alt: "Paso 7",
                },
                {
                    src: icons.bodega_reajuste_p8,
                    alt: "Paso 8",
                },
            ],
        };
    }
    componentWillMount() {
        this.props.setSeleccionados([]);
        this.props.listar(this.props.page);
    }

    onClickAyuda = (item) => {
        if (item.key === "ingreso") {
            this.setState({
                itemsImagenes: this.state.itemsBodegaIngreso,
            });
            this.openModal();
        } else if (item.key === "baja") {
            this.setState({
                itemsImagenes: this.state.itemsBodegaBaja,
            });
            this.openModal();
        } else if (item.key === "reajuste") {
            this.setState({
                itemsImagenes: this.state.itemsBodegaReajuste,
            });
            this.openModal();
        }
    };

    closeModal = () => {
        this.setState({ modalAyuda: false });
    };
    openModal = () => {
        this.setState({ modalAyuda: true });
    };

    render() {
        const { data, loader, usuario, filtro } = this.props;
        const { modalAyuda, itemsImagenes } = this.state;
        // bind
        const { filtroChange } = this.props;

        const options = _.cloneDeep(tableOptions);
        options.noDataText = loader ? "Cargando..." : options.noDataText;
        options.page = this.props.page;
        options.onPageChange = this.props.listar;
        options.onSortChange = this.props.sortChange;

        return (
            <div className="row">
                <div className="col-lg-12 col-md-12 col-sm-12">
                    {/* <div style={{position:"absolute", right: "15px", top: "-15px"}}>
                        <button className="btn btn-ayuda fnt-16 d-flex align-items-center justify-content-center" style={{width: "2rem", height: "2rem"}}>
                            <img src={icons.ayuda} alt="ayuda" title="Ayuda" style={{margin: "0", height:"1.1rem"}}/>
                            <DropDownMenu items={this.state.dropdownItems} onClick={this.onClickAyuda} direction={DropDownDirection.DownLeft} className="fnt-10"/>
                        </button>
                    </div> */}
                    <div className="d-flex justify-content-between flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row border-bottom mb-3">
                        <div className="text-center flex1">
                            {usuario.igreso_mercaderia ? (
                                <div className="d-flex flex-column align-items-center">
                                    <img
                                        className="icon-img"
                                        style={{
                                            maxWidth: "60px",
                                            width: "48px",
                                            marginBottom: "10px",
                                            cursor: "default",
                                        }}
                                        src={icono_traslados}
                                        alt=""
                                    />
                                    <Link
                                        className="a-remove-fromat d-flex flex-column align-items-center"
                                        to="/bodega/listado_movimientos/"
                                    >
                                        <button className="btn btn-outline-primary btn-bodega">
                                            Listado de movimientos
                                        </button>
                                    </Link>
                                </div>
                            ) : (
                                <div className="d-flex flex-column align-items-center">
                                    <img
                                        className="icon-img"
                                        style={{
                                            maxWidth: "60px",
                                            width: "48px",
                                            marginBottom: "10px",
                                            opacity: 0.5,
                                            cursor: "default",
                                        }}
                                        src={icono_traslados}
                                        alt=""
                                    />

                                    <button
                                        disabled
                                        className="btn btn-outline-primary btn-bodega"
                                    >
                                        Listado de movimientos
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className="text-center flex1">
                            {usuario.baja_mercaderia ? (
                                <div className="d-flex flex-column align-items-center">
                                    <img
                                        className="icon-img"
                                        style={{
                                            maxWidth: "60px",
                                            width: "48px",
                                            marginBottom: "10px",
                                            cursor: "default",
                                        }}
                                        src={icono_devolucion}
                                        alt=""
                                    />
                                    <Link
                                        className="a-remove-fromat d-flex flex-column align-items-center"
                                        to="/bodega/devolucion_compra/"
                                    >
                                        <button className="btn btn-outline-primary btn-bodega">
                                            Devolucion Proveedor
                                        </button>
                                    </Link>
                                </div>
                            ) : (
                                <div className="d-flex flex-column align-items-center">
                                    <img
                                        className="icon-img"
                                        style={{
                                            maxWidth: "60px",
                                            width: "48px",
                                            marginBottom: "10px",
                                            opacity: 0.5,
                                            cursor: "default",
                                        }}
                                        src={icono_devolucion}
                                        alt=""
                                    />

                                    <button
                                        disabled
                                        className="btn btn-outline-primary btn-bodega"
                                    >
                                        Devolucion Proveedor
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className="text-center flex1">
                            {usuario.salida_mercaderia ? (
                                <Link
                                    className="a-remove-fromat d-flex flex-column align-items-center"
                                    to="/bodega/nota_credito_cliente/"
                                >
                                    <img
                                        className="icon-img"
                                        style={{
                                            maxWidth: "60px",
                                            width: "48px",
                                            marginBottom: "10px",
                                        }}
                                        src={icono_ordenes_venta}
                                        alt=""
                                    />

                                    <button className="btn btn-outline-primary btn-bodega">
                                        Nota Crédito Cliente
                                    </button>
                                </Link>
                            ) : (
                                <div className="d-flex flex-column align-items-center">
                                    <img
                                        className="icon-img"
                                        style={{
                                            maxWidth: "60px",
                                            width: "48px",
                                            marginBottom: "10px",
                                            opacity: 0.5,
                                            cursor: "default",
                                        }}
                                        src={icono_ordenes_venta}
                                        alt=""
                                    />

                                    <button
                                        disabled
                                        className="btn btn-outline-primary btn-bodega"
                                    >
                                        Nota Crédito Cliente
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className="text-center flex1">
                            {usuario.reajuste_mercaderia ? (
                                <div className="d-flex flex-column align-items-center">
                                    <img
                                        className="icon-img"
                                        style={{
                                            maxWidth: "60px",
                                            width: "48px",
                                            marginBottom: "10px",
                                            cursor: "default",
                                        }}
                                        src={icono_reajuste}
                                        alt=""
                                    />
                                    <Link
                                        className="mb1 a-remove-fromat"
                                        to="/bodega/reajuste/"
                                    >
                                        <button className="btn btn-outline-primary btn-bodega">
                                            Hacer Reajuste
                                        </button>
                                    </Link>
                                </div>
                            ) : (
                                <div className="d-flex flex-column align-items-center">
                                    <img
                                        className="icon-img"
                                        style={{
                                            maxWidth: "60px",
                                            width: "48px",
                                            marginBottom: -10,
                                            marginBottom: "10px",
                                            opacity: 0.5,
                                            cursor: "default",
                                        }}
                                        src={icono_reajuste}
                                        alt=""
                                    />

                                    <button
                                        disabled
                                        className="btn btn-outline-primary btn-bodega"
                                    >
                                        Hacer Reajuste
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="grid-container">
                        <div
                            className="px-3 pt-3 d-flex flex-wrap flex-column flex-sm-column flex-md-row flex-lg-row flex-xl-row justify-content-start"
                            style={{ flex: "3" }}
                        >
                            <div className="flex2">
                                <label>Filtrar por</label>
                                <div className="d-flex flex-column">
                                    <div className="d-flex flex-row">
                                        <div className="radio c-radio c-radio-nofont d-flex ml-10">
                                            <label className="negro-dark2 font-weight-normal">
                                                <input
                                                    name="todos"
                                                    type="radio"
                                                    value="true"
                                                    checked={filtro === "todos"}
                                                    onChange={() => {
                                                        filtroChange("todos");
                                                    }}
                                                />
                                                <span />
                                                Todos
                                            </label>
                                        </div>
                                        <div className="radio c-radio c-radio-nofont d-flex ml-10">
                                            <label className="negro-dark2 font-weight-normal">
                                                <input
                                                    name="con_inventario"
                                                    type="radio"
                                                    value="false"
                                                    checked={
                                                        filtro ===
                                                        "con_inventario"
                                                    }
                                                    onChange={() => {
                                                        filtroChange(
                                                            "con_inventario"
                                                        );
                                                    }}
                                                />
                                                <span />
                                                Con inventario
                                            </label>
                                        </div>
                                        <div className="radio c-radio c-radio-nofont d-flex ml-10">
                                            <label className="negro-dark2 font-weight-normal">
                                                <input
                                                    name="sin_inventario"
                                                    type="radio"
                                                    value="false"
                                                    checked={
                                                        filtro ===
                                                        "sin_inventario"
                                                    }
                                                    onChange={() => {
                                                        filtroChange(
                                                            "sin_inventario"
                                                        );
                                                    }}
                                                />
                                                <span />
                                                Sin inventario
                                            </label>
                                        </div>
                                        <div className="radio c-radio c-radio-nofont d-flex ml-10">
                                            <label className="negro-dark2 font-weight-normal">
                                                <input
                                                    name="inventario_negativo"
                                                    type="radio"
                                                    value="false"
                                                    checked={
                                                        filtro ===
                                                        "inventario_negativo"
                                                    }
                                                    onChange={() => {
                                                        filtroChange(
                                                            "inventario_negativo"
                                                        );
                                                    }}
                                                />
                                                <span />
                                                Con inventario negativo
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="grid-titulo">
                            <Toolbar
                                titulo={"Bodega"}
                                buscar={this.props.buscar}
                                search={this.props.search}
                                // estado_descarga={estado_descarga}
                                // url_impresion={"/bodega/impresion_productos"}
                                // itemsAyuda={dropdownItems}
                                // actionAyuda={this.onClickAyuda}
                                // descarga_excel={descargarListado}
                            />
                        </div>
                        <LoadMask loading={loader} light blur radius>
                            <BootstrapTable
                                data={loader ? [] : data.results}
                                remote
                                pagination
                                hover
                                fetchInfo={{ dataTotalSize: data.count }}
                                options={options}
                            >
                                <TableHeaderColumn
                                    width="0"
                                    isKey
                                    dataField="id"
                                >
                                    ID
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    // width="8%"
                                    dataField="nombre"
                                    dataFormat={(cell, row) => {
                                        return (
                                            <RenderImage
                                                src={row.producto.img_cropped}
                                                alt={cell}
                                            />
                                        );
                                    }}
                                    dataAlign="left"
                                >
                                    Img
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    // width="8%"
                                    tdStyle={BreakLine}
                                    thStyle={BreakLine}
                                    dataField="producto__codigo"
                                    dataFormat={(cell, row) => {
                                        return (
                                            <div>
                                                <b>{row.producto.codigo}</b>
                                                <div>{row.codigo}</div>
                                            </div>
                                        );
                                    }}
                                    dataSort
                                >
                                    Código
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    // width="10%"
                                    dataField="producto__codigo_equivalente_1"
                                    dataFormat={(cell, row) => {
                                        return (
                                            <div>
                                                <b>
                                                    {
                                                        row.producto
                                                            .codigo_equivalente_1
                                                    }
                                                </b>
                                                <div>
                                                    {row.codigo_equivalente_1}
                                                </div>
                                            </div>
                                        );
                                    }}
                                    dataSort
                                >
                                    Equivalente 1
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    // width="12%"
                                    dataField="producto__nombre"
                                    tdStyle={BreakLine}
                                    thStyle={BreakLine}
                                    dataFormat={(cell, row) => {
                                        return (
                                            <div>
                                                <b>{row.producto.nombre}</b>
                                                {/* <div>{row.nombre}</div> */}
                                            </div>
                                        );
                                    }}
                                    dataSort
                                >
                                    Nombre
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    // width="12%"
                                    dataField="costo"
                                    dataSort
                                    dataFormat={(cell, row) => {
                                        return (
                                            <div>
                                                <p>{`Q ${row.costo}`}</p>
                                            </div>
                                        );
                                    }}
                                    formatoCostoQuetzales
                                    dataAlign="left"
                                >
                                    Costo Q
                                </TableHeaderColumn>

                                <TableHeaderColumn
                                    // width="12%"
                                    dataField="costo_dolares"
                                    dataSort
                                    dataFormat={formatoCostoDolares}
                                    dataAlign="left"
                                >
                                    Costo $
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    // width="12%"
                                    dataField="precio_mostrador_calculado"
                                    dataSort
                                    dataFormat={(cell, row) => {
                                        if (cell) {
                                            return (
                                                <RenderMoneda monto={cell} />
                                            );
                                        }
                                        return "---";
                                    }}
                                    dataAlign="left"
                                >
                                    Precio mostrador Q
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    dataField="fecha_ultima_compra"
                                    dataSort
                                    tdStyle={BreakLine}
                                    thStyle={BreakLine}
                                    dataAlign="left"
                                    dataFormat={(cell, row) => {
                                        return <RenderDateTime fecha={cell} />;
                                    }}
                                >
                                    Última compra
                                </TableHeaderColumn>
                                {/* <TableHeaderColumn
                                    // width="12%"
                                    dataField="inventario_transito"
                                    dataFormat={(cell, row) => {
                                        return <div>{cell}</div>;
                                    }}
                                    dataAlign="right"
                                >
                                    Producto en tránsito
                                </TableHeaderColumn>
                                <TableHeaderColumn
                                    // width="12%"
                                    dataField="inventario_a_recibir"
                                    dataFormat={(cell, row) => {
                                        return <div>{cell}</div>;
                                    }}
                                    dataAlign="right"
                                >
                                    Producto por recibir
                                </TableHeaderColumn> */}
                                <TableHeaderColumn
                                    // width="9%"
                                    dataField="inventario"
                                    dataFormat={(cell, row) => {
                                        return (
                                            <div
                                                className={
                                                    row.minimo_existencias !==
                                                        null &&
                                                    row.minimo_existencias >=
                                                        cell
                                                        ? "rojo"
                                                        : ""
                                                }
                                            >
                                                {row.minimo_existencias !==
                                                    null &&
                                                    row.minimo_existencias >=
                                                        cell && (
                                                        <i className="fa fa-exclamation-circle" />
                                                    )}
                                                &nbsp;
                                                {/* {row.producto.a_granel
                                                    ? cell.toFixed(3)
                                                    : cell.toFixed(2)
                                                } */}
                                                <label className="font-weight-bold font-p">
                                                    {cell}
                                                </label>
                                            </div>
                                        );
                                    }}
                                    dataAlign="right"
                                >
                                    Inventario
                                </TableHeaderColumn>
                            </BootstrapTable>
                        </LoadMask>
                    </div>
                </div>
                <ModalAyuda
                    open={modalAyuda}
                    closeModal={this.closeModal}
                    openModal={this.openModal}
                    items={itemsImagenes}
                />
            </div>
        );
    }
}

export default Apertura;
